// extracted by mini-css-extract-plugin
export default {"snackbar":"snackbar_snackbar__oi4CT","show":"snackbar_show__cz-Oo","fadein":"snackbar_fadein__lO8Jj","fadeout":"snackbar_fadeout__a4GKZ"};